module.exports = __webpack_public_path__ + "static/img/841b7c6b.png";